export default async function GetBeneficiaries(
    policyNumber) {
    const baseUrl = "/api/TAL/PolicyDetails/GetBeneficiaries?policyNumber="+ policyNumber;
    // const baseUrl = "https://adviser-local-sitecore10.delivery.lan" + "/api/TAL/PolicyDetails/GetBeneficiaries?policyNumber="+ policyNumber; // note: local testing

    try {
        const response = await fetch(baseUrl, {
            "method": "GET"
        });

        if (!response) {
            throw Error("No response");
        } else if (!response.ok) {
            throw Error(response.statusText);
        }

        const result = await response.json();

        return result;
    } catch (error) {
        console.log(error);

    }
}
